import type { Action } from 'state/actions';
import { removeKey, removeKeys } from 'state/utils/collection';

import type { PatchedFieldsStateMap } from '../formData.model';

export function patchedFieldsReducer(state: PatchedFieldsStateMap = {}, action: Action): PatchedFieldsStateMap {
  switch (action.type) {
    case 'PATCHED_FIELDS_COMPUTED':
      return { ...state, [action.formId]: action.patchedFields };
    case 'WORKSPACE_TAB_REMOVED':
      return removeKey(state, action.id);
    case 'WORKSPACE_RESET_TAB_REQUESTED':
      return removeKey(state, action.tabId);
    case 'FORM_RELOADED':
      return removeKey(state, action.tabId);
    case 'DEFAULT_FORM_RECEIVED':
      return removeKey(state, action.tabId);
    case 'BATCH_FORMS_DELETED':
      return removeKeys(state, action.formIds);
    case 'BATCH_FORMS_RESTORE_REQUESTED':
      return removeKeys(state, action.formIds);
    default:
      return state;
  }
}
